import {
  MyAccountActiveProps,
  MyAccountTabsEnum,
} from "@routes/MyAccount/utils/types";

import MyAccountPopoverLoginMyBTLoginState from "./MyAccountPopoverLoginMyBTLoginState";
import MyAccountReadingHistoryPopoverLoginState from "./MyAccountReadingHistoryPopoverLoginState";

export default function MyAccountPopoverLoginActiveTabs({
  activeTab,
}: MyAccountActiveProps): React.ReactElement {
  if (activeTab === MyAccountTabsEnum.myBT)
    return <MyAccountPopoverLoginMyBTLoginState />;

  if (activeTab === MyAccountTabsEnum.recent)
    return <MyAccountReadingHistoryPopoverLoginState />;

  return <></>;
}
